import {
  InfoIcon,
  SectionedHorizontalLinedTable,
  Select,
  SwitchAppButton,
} from "../../components";
import { SectionedHeader } from "../../components/SectionedHorizontalLinedTable/SectionedHeader";
import { LeftRightSection } from "../../components/SectionedHorizontalLinedTable/LeftRightSection";
import { CheckboxLRSection } from "../../components/SectionedHorizontalLinedTable/LeftRightSection/CheckboxLRSection";
import { ActivationRequiredWarning } from "../../components";
import {
  HookFormCheckbox,
  HookFormSelect,
  HookFormToggle,
  SubmitButton,
  TextInput,
} from "../../hook-form";
import {
  ICheckoutAndPaymentLinkSettings,
  IHookForm,
} from "../../interfaces-and-types";
import { Link } from "react-router-dom";
import {
  chargeBearer,
  checkoutMethodsOrders,
  failedPaymentResolutionTypes,
} from "../../enums";

export const View = ({
  goBack,
  isDirty,
  show_payment_providersFormValue,
  onToggleShowPaymentProviders,
  formValues,
  handleSubmit,
  errors,
  register,
}: IHookForm<ICheckoutAndPaymentLinkSettings> & {
  formValues: ICheckoutAndPaymentLinkSettings;
  show_payment_providersFormValue: boolean;
  onToggleShowPaymentProviders: () => void;
  goBack: () => void;
  isDirty: boolean;
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <ActivationRequiredWarning
        title="Please you need to activate your profile"
        subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <SectionedHorizontalLinedTable>
        {/* <SectionedHeader
          hasBorder={true}
          mainHead="Store policies"
          subHead="Select details you want to add about your store policies on your payment page."
        />
        <LeftRightSection
          hasBorder={true}
          leftText="Refund and return policy"
          rightText={
            <HookFormCheckbox
              name="display_links_to_your_terms_and_policies"
              label="Display links to your terms of service and privacy policies"
              containerClassName="settings-checkbox"
              // infoIconText="xxxxxx"
              register={register}
              errors={errors}
            />
          }
        />
        <LeftRightSection
          hasBorder={true}
          leftText="Contact information"
          rightText={
            <HookFormCheckbox
              name="display_support_contact_info"
              label="Display support contact information"
              containerClassName="settings-checkbox"
              // infoIconText="xxxxxx"
              register={register}
              errors={errors}
            />
          }
        /> */}
        {/* <LeftRightSection
          hasBorder={false}
          leftText="Legal policies"
          rightText={
            <HookFormCheckbox
              name="xxxxxxxxx"
              label="Display links to your terms of service and privacy policies"
              containerClassName="settings-checkbox"
              // infoIconText="xxxxxx"
              register={register}
              errors={errors}
            />
          }
        /> */}

        <SectionedHeader
          className="more-margin"
          hasBorder={true}
          mainHead="Payment method options"
          subHead="These settings apply to payment pages you create using SwitchApp Checkout and Payment Links."
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Charge bearer"
          rightText={
            // <Select
            //   label=""
            //   title="Select charge bearer"
            //   placeholder="Select charge bearer"
            //   {...register("bearer")}
            //   className="font-ctm--bold pt-n5"
            //   selectItems={[
            //     {
            //       text: "customer",
            //       value: chargeBearer.customer,
            //     },
            //     {
            //       text: "merchant",
            //       value: chargeBearer.merchant,
            //     },
            //   ]}
            // />

            <div className="three-sectiond-row">
              <div className="select">
                <select {...register("bearer")}>
                  <option value={"customer"}>Customer</option>
                  <option value={"merchant"}>Merchant</option>
                </select>{" "}
                bears the transaction charges
              </div>
            </div>
          }
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Faster checkout"
          rightText={
            // <HookFormToggle
            //   name="include_payment_gateways_and_methods"
            //   label="Show payment providers on checkout page"
            //   labelRight
            //   labelOff="No"
            //   labelOn="Yes"
            //   defaultToggled={show_payment_providersFormValue}
            //   onToggle={onToggleShowPaymentProviders}
            //   containerClassName="settings-toggle"
            //   infoIconText={
            //     <>
            //       Payment providers will be displayed along with the default
            //       card checkout view
            //       <br />
            //       <hr />
            //       Users can pay via any of the enabled payment methods from
            //       enabled providers.
            //     </>
            //   }
            //   register={register}
            //   errors={errors}
            // />

            <HookFormCheckbox
              name="include_payment_gateways_and_methods"
              label="Show payment providers on checkout page"
              containerClassName="settings-checkbox"
              infoIconText={
                <>
                  Payment providers will be displayed along with the default
                  card checkout view
                  <br />
                  <hr />
                  Users can pay via any of the enabled payment methods from
                  enabled providers.
                </>
              }
              register={register}
              errors={errors}
            />
          }
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Checkout Methods Order"
          rightText={
            <div className="three-sectiond-row">
              <div className="select">
                Show{" "}
                <select {...register("checkout_methods_order")}>
                  <option value={checkoutMethodsOrders.gateways}>
                    Gateways
                  </option>
                  <option value={checkoutMethodsOrders.card}>Card</option>
                </select>{" "}
                first on checkout page
              </div>
            </div>
          }
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Appearance"
          rightText={
            <div>
              Go to{" "}
              <Link to="/settings/branding/reciept" className="switchapp-link">
                branding settings
              </Link>{" "}
              to upload your icon or logo, and set colors.
            </div>
          }
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Public information"
          rightText={
            <div>
              Go to{" "}
              <Link to="/settings/business-details" className="switchapp-link">
                business details
              </Link>{" "}
              to update your business name.
            </div>
          }
        />

        <LeftRightSection
          hasBorder={false}
          leftText="Display gateway"
          rightText={
            <div className="three-sectiond-row">
              <div className="select">
                <select {...register("gateway_recommendation_type")}>
                  <option value={"region"}>
                    Display gateway to customers by region
                  </option>

                  <option value={"checkoutUrl"}>
                    Display gateway to customers by checkout URL
                  </option>

                  <option value={"amount"}>
                    Display gateway to customers by amount
                  </option>

                  <option value={"currency"}>
                    Display gateway to customers by currency
                  </option>
                </select>
              </div>

              <div className="button-group"></div>
            </div>
          }
        />

        <SectionedHeader
          className="more-margin"
          hasBorder={true}
          mainHead="Automatic Failed Payment Mgmt"
          subHead="These settings determine what happens when a customer pays an incomplete amount."
        />

        <LeftRightSection
          hasBorder={true}
          leftText={
            <>
              Resolve Failed Payments By
              <InfoIcon message="Select the action to perform when a payment issue arises." />
            </>
          }
          rightText={
            <div className="three-sectiond-row">
              <div className="select">
                <select {...register("failed_payment_auto_resolution_type")}>
                  <option value={failedPaymentResolutionTypes.instantRefund}>
                    Instant Refund
                  </option>

                  <option value={failedPaymentResolutionTypes.noRefund}>
                    No Refund
                  </option>

                  <option value={failedPaymentResolutionTypes.delayedRefund}>
                    Delayed Refund
                  </option>

                  <option value={failedPaymentResolutionTypes.acceptAsPartial}>
                    Accept As Partial
                  </option>

                  <option value={failedPaymentResolutionTypes.settleToBalance}>
                    Settle To Balance
                  </option>
                </select>
              </div>
            </div>
          }
        />

        {formValues.failed_payment_auto_resolution_type !==
        failedPaymentResolutionTypes.instantRefund ? null : (
          <LeftRightSection
            hasBorder={true}
            leftText={
              <>
                Instant Refund Threshold %
                <InfoIcon message="Initiate an instant refund if the payment is less than this percentage of the actual amount." />
              </>
            }
            rightText={
              <TextInput
                name="instant_refund_incomplete_amount_threshold_percentage"
                label=""
                type="text"
                containerClassName="no-top-margin"
                className="settings-input"
                register={register}
                errors={errors}
              />
            }
          />
        )}

        {formValues.failed_payment_auto_resolution_type !==
        failedPaymentResolutionTypes.delayedRefund ? null : (
          <LeftRightSection
            hasBorder={true}
            leftText={
              <>
                Delay Refunds For
                <InfoIcon message="This determines the duration in hours before refunds are initiated. The max is 48 hours." />
              </>
            }
            rightText={
              <div className="flex-container row justify-content--end align-item--center">
                <div>
                  <TextInput
                    name="delayed_refund_duration_hours"
                    label=""
                    type="text"
                    containerClassName="no-top-margin"
                    register={register}
                    errors={errors}
                  />
                </div>
                <span>Hour(s)</span>
              </div>
            }
          />
        )}

        <div className="flex-container col align-items--end pr-5 mr-5 mt-5">
          <div className="flex-container row">
            <SwitchAppButton size="sm" kind="secondary" onClick={goBack}>
              Cancel
            </SwitchAppButton>
            <SubmitButton
              size="sm"
              className="ml-5"
              showChildrenWithLoadingIcon
            >
              Save
            </SubmitButton>
          </div>
        </div>
      </SectionedHorizontalLinedTable>
    </form>
  );
};
